import { Injectable } from '@angular/core';
import { saveAs } from 'file-saver';
import { Observable } from 'rxjs';
import { mapTo, tap } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UrlBuilderService } from '@common/services/url-builder.service';


const getFileNameFromResponseContentDisposition = (headers: HttpHeaders ) => {
  const contentDisposition = headers.get('content-disposition') || '';
  const matches = /filename="([^;]+)"/ig.exec(contentDisposition);
  const fileName = (matches[1] || 'untitled').trim();
  return fileName;
};

@Injectable({
  providedIn: 'root'
})
export class LogFilesService {

  constructor(
    private readonly urlBuilder: UrlBuilderService,
    private readonly http: HttpClient) {
  }


  getLogsZip(): Observable<boolean> {
    const url = this.urlBuilder.getUrl('logfiles/download');
    
    return this.http.get(url, { responseType: 'blob', observe: 'response' }).pipe(
      tap(res => {
        console.log(res);
        const fileName = getFileNameFromResponseContentDisposition(res.headers);
        
        saveAs(res.body, fileName);
      })
      , mapTo(true)
    );
  }


}
